import { useEffect } from "react";
import { useLocation } from "react-router";

const ScrollToTop = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    //window.scrollTo(0, 0);
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Esto hará que el desplazamiento sea instantáneo
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;